import { Match } from '../types';
import {
  updateMatchBetCourses,
  updateMatchPeriodName,
  updateMatchScore,
  updateMatchSets,
  updateMatchMetaStatus,
  updateWinnerStyle,
  updateMatchResultOfCategoryOthers,
} from '../utils/index';

export const singleMatchController = (
  wrapper: HTMLElement,
  matchData: Match,
  tipsportCourses: any,
  xmlData: any
) => {
  const matchElement = wrapper.querySelector<HTMLElement>(`[data-match-id="${matchData.id}"]`);
  // const matchElement = wrapper.querySelector<HTMLElement>(`[data-match-id="361056"]`);
  console.log(matchElement, 'matchElement');

  if (!matchElement) {
    console.warn(`Element s [data-match-id="${matchData.id}"] nebyl nalezen.`);
    return;
  }

  const matchStatus = matchData.xml_status.toLowerCase();
  const matchSport = matchElement.getAttribute('data-match-sport');
  const isLiveMatch = matchStatus === 'live';
  const isFinMatch = matchStatus === 'fin';

  updateMatchMetaStatus(matchElement, matchStatus);
  updateMatchScore({ matchElement, matchData, matchStatus });
  updateMatchBetCourses(matchElement, matchStatus, tipsportCourses);
  updateMatchPeriodName(matchElement, xmlData?.status);
  updateMatchResultOfCategoryOthers({ matchElement, result: matchData?.result_string });

  if (isFinMatch) {
    updateWinnerStyle({ matchElement, score1: matchData.score1, score2: matchData.score2 });
  }

  if ((isLiveMatch || isFinMatch) && xmlData?.periods && matchSport === 'ten') {
    updateMatchSets(matchElement, xmlData.periods);
  }
};
